//* #12304: Bridge the member grid's live filter model between the grid page
//* (member-maintenance/index.js) and the ribbon sections, which are rendered
//* through the global ribbon portal and cannot receive it via props.
export const detailGridFiltersStore = { current: undefined };
